import { Entity } from "@common/types/entity";
import { formatISO } from "date-fns";
import { ExpenseByVendorSort } from "@common/helpers/expenseByVendorSort";
import { ReportFormat } from "@common/helpers/reports";
import {
    AccountingReportType,
    ACCOUNTING_REPORT_LABELS,
} from "@common/types/reports/report-type";
import { exportExpenseByVendor } from "@api/accountingReports.api";
import { AccountingReportFilters } from "@components/accounting/types";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";
import { ReportSettingRowVisibility } from "@common/types/reports/report-settings";
import { pickXlsxExportRowVisibility } from "@components/accounting/xlsxExportRowVisibility";

interface DownloadParameters {
    entity: Entity;
    format: ReportFormat;
    date?: Date;
}

export function useExpenseByVendorDownload(
    requestDto: AccountingReportFilters,
    sort?: ExpenseByVendorSort,
    rowVisibility?: ReportSettingRowVisibility,
) {
    return useFileDownload(
        async ({ entity, format, date }: DownloadParameters) => {
            if (!requestDto) {
                return;
            }

            const modifiedRequestDto = {
                ...requestDto,
                format,
            };

            const exportRowVisibility = pickXlsxExportRowVisibility(
                format,
                rowVisibility,
            );

            const response = await exportExpenseByVendor(
                modifiedRequestDto,
                sort,
                exportRowVisibility,
            );

            if (!response) {
                return;
            }

            const reportTypeTitle =
                ACCOUNTING_REPORT_LABELS[
                    AccountingReportType.EXPENSE_BY_VENDOR
                ];
            const fileName = `${entity.name} - ${reportTypeTitle} - ${date ? formatISO(date, { representation: "date" }) : ""}.${format}`;

            saveBlobResponse(response, fileName);
        },
    );
}
